import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'start.learning': {
    id: 'start.learning',
    defaultMessage: 'Start learning',
    description: 'Header text for logistration MFE pages',
  },
  'with.site.name': {
    id: 'with.site.name',
    defaultMessage: 'with {siteName}',
    description: 'Header text with site name for logistration MFE pages',
  },
  "initial.display.message": {
    id: "initial.display.message",
    defaultMessage: "Log in or register to explore new ways to learn and teach.",
    description: "Initial message displayed in the authn container",
  },
});

export default messages;
